
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n';  // ✅ ADD THIS
import App from './App';
import reportWebVitals from './reportWebVitals';
import Swal from 'sweetalert2';
import axios from "axios";   // ✅ ADD THIS

// ✅ Axios global config
axios.defaults.withCredentials = true;

axios.interceptors.request.use((config) => {
  const xsrfToken = document.cookie
    .split("; ")
    .find(row => row.startsWith("XSRF-TOKEN="))
    ?.split("=")[1];

  if (xsrfToken) {
    config.headers["X-XSRF-TOKEN"] = xsrfToken;
  }

  return config;
});

window.Swal = Swal;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();

